.ag{overflow:hidden;}